module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/banner-5-1.e0ae15c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/banner-5-1.jpg
// module id = QPQ1
// module chunks = 3